import React, { useEffect, useMemo, useState } from 'react';
import { IonAvatar, IonImg, IonItem, IonLabel, IonList, IonText } from '@ionic/react';
import { PaySelectors } from 'redux/PayRedux';
import { useSelector } from 'react-redux';
import { AppSelectors } from 'redux/AppRedux';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/named
import { OfferItem } from 'components/loyalty';
import LoyaltyTermsModal from 'containers/tab/LoyaltyTermsModal';
import moment from 'moment';
import { AuthSelectors } from 'redux/AuthRedux';
import BirthdayModal from 'containers/tab/BirthdayModal';

function LoyaltyPgMyOffers({ programId, showModal }) {
  const loyaltyPoints = useSelector(PaySelectors.selectLoyaltyPoints);
  const loyaltyPrograms = useSelector(PaySelectors.selectLoyaltyPrograms);
  const loyaltyOffers = useSelector(PaySelectors.selectLoyaltyAutoOffers);
  const user = useSelector(AuthSelectors.selectUser);
  const [isOpen,setIsOpen]=useState(false)
console.log(user)
  const [showOptOutAlert, setShowOptOutAlert] = useState(false);
  const [termsEndDate, setTermsEndDate] = useState('');

  const venues = useSelector(AppSelectors.selectVenues);

  const handleClose=()=>{
    setIsOpen(false)
  }

  const currentProgramInfo = useMemo(() => {
    const filterProgram = loyaltyPrograms.filter(item => item.id === programId);

    if (filterProgram.length > 0) {
      return filterProgram[0];
    }

    return null;
  }, [loyaltyPrograms, programId]);

  const availablePoints = useMemo(() => {
    const filterLoyaltyPoints = loyaltyPoints.filter(item => item.programId === programId);

    const points = filterLoyaltyPoints.reduce(
      (sumPoints, item) => {
        return sumPoints + item.availablePoints;
      }, 0);

    return points.toFixed(0);
  }, [loyaltyPoints]);

  const venueDetail = useMemo(() => {
    const venueIds = currentProgramInfo?.venueIds;

    if (!venueIds || !venueIds?.length) {
      return null;
    }

    const filterVenue = venues.filter(item => venueIds.some(id => id === item.id));

    if (filterVenue?.length > 0) {
      return filterVenue[0];
    }

    return null;
  }, [venues, currentProgramInfo]);

  const sortedFilterOffers = useMemo(() => {
    let arrayOffers = loyaltyOffers // annual and auto offers

    arrayOffers = arrayOffers.filter(offer => {
      if (offer && offer.programId === programId) {
        const currentDate = moment();
        const weekEnd = currentDate.clone().endOf('week');
        const monthEnd = currentDate.clone().endOf('month');
        let endOfDate = currentDate;

        if (offer.type === 'annual') {
          if (offer.durationType === 'limited') {
            endOfDate = offer.endDate;
          } else if (offer.annualEventTimeFrame === 'day') {
            endOfDate = currentDate;
          } else if (offer.annualEventTimeFrame === 'week') {
            endOfDate = weekEnd;
          } else {
            endOfDate = monthEnd;
          }
        } else {
          endOfDate = offer.endDate;
        }

        const expiresAt = moment(endOfDate).add(1, 'day');
        const now = moment().startOf('day');

        return expiresAt.isSameOrAfter(now);
      }

      return false;
    });

    return arrayOffers.sort(((a, b) => a.expiresAt - b.expiresAt));
  }, [loyaltyOffers, programId]);

  useEffect(() => {
    setIsOpen(
      sortedFilterOffers.some(
        (autoOfferItem) =>
          autoOfferItem.annualEventType === 'birthday' && !user?.birthday
      ) && user.isLoyaltyUser
    );
  }, [sortedFilterOffers]);
  return (
    <>
      <IonList>
        <IonItem lines="none" className="mt-2x">
          <div className="d-flex-content d-flex-center loyalty-venue-logo-wrapper">
            <IonAvatar slot="start" className="loyalty-venue-logo-size">
              <IonImg src={venueDetail?.logo} />
            </IonAvatar>
          </div>
        </IonItem>

        <IonItem lines="none" className="mb-5x">
          <div className="d-flex-content d-flex-center">
            <IonLabel className="text-center ion-text-wrap">
              <h2>Your {venueDetail?.name} Program</h2>
            </IonLabel>

            <div className="loyalty-coin-wrap">
              <IonLabel className="ion-text-wrap mr-1">
                <h6>You have</h6>
              </IonLabel>

              <IonLabel className="ion-text-wrap mr-1">
                <IonText color="tertiary">
                  <h6>
                    <b>{availablePoints}</b>
                  </h6>
                </IonText>
              </IonLabel>

              <IonImg src="/assets/vemos-coin.png" className="coin-img-icon" />
            </div>
          </div>
        </IonItem>

        {sortedFilterOffers.map((autoOfferItem) => {

          return autoOfferItem.annualEventType !== 'birthday' ? (
            <OfferItem
              key={autoOfferItem.id}
              item={autoOfferItem}
              setShowAlert={setShowOptOutAlert}
              setTermsEndDate={setTermsEndDate}
            />
          ) : user.birthday ? (
            <OfferItem
              key={autoOfferItem.id}
              item={autoOfferItem}
              setShowAlert={setShowOptOutAlert}
              setTermsEndDate={setTermsEndDate}
            />
          ) : null;
        })}
      </IonList>

      <LoyaltyTermsModal
        isOpen={showOptOutAlert}
        setShowAlert={setShowOptOutAlert}
        termsEndDate={termsEndDate}
      />
    {showModal &&  <BirthdayModal open={isOpen} onClose={handleClose} />}
    </>
  );
}

LoyaltyPgMyOffers.propTypes = {
  programId: PropTypes.string,
};

export default LoyaltyPgMyOffers;
